import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaUser, FaEnvelope, FaPhone, FaLock, FaEye, FaEyeSlash, FaRocket } from 'react-icons/fa';
import { useAuth } from '../contexts/AuthContext';
import { registerUser } from '../utils/api';
import './AuthPages.css';

const Register = () => {
  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', password: '', confirmPassword: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    if (!/^\d{10}$/.test(formData.phone)) {
      setError('Enter a valid 10-digit phone number');
      return;
    }

    setIsLoading(true);
    try {
      const data = await registerUser({
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        password: formData.password,
      });
      login(data.user, data.token);
      navigate('/my-applications');
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-header">
          <div className="auth-icon">📋</div>
          <h1>Create Account</h1>
          <p>Register to track your loan applications</p>
        </div>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="auth-field">
            <label><FaUser className="field-icon" /> Full Name</label>
            <input
              type="text" name="name" value={formData.name}
              onChange={handleChange} placeholder="Enter your full name" required
            />
          </div>

          <div className="auth-field">
            <label><FaEnvelope className="field-icon" /> Email Address</label>
            <input
              type="email" name="email" value={formData.email}
              onChange={handleChange} placeholder="Enter your email" required
            />
          </div>

          <div className="auth-field">
            <label><FaPhone className="field-icon" /> Phone Number</label>
            <input
              type="tel" name="phone" value={formData.phone}
              onChange={handleChange} placeholder="10-digit mobile number"
              maxLength="10" required
            />
          </div>

          <div className="auth-field">
            <label><FaLock className="field-icon" /> Password</label>
            <div className="password-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                name="password" value={formData.password}
                onChange={handleChange} placeholder="Minimum 6 characters" required
              />
              <button type="button" className="toggle-password" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>

          <div className="auth-field">
            <label><FaLock className="field-icon" /> Confirm Password</label>
            <div className="password-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                name="confirmPassword" value={formData.confirmPassword}
                onChange={handleChange} placeholder="Re-enter your password" required
              />
            </div>
          </div>

          <button type="submit" className="auth-submit-btn" disabled={isLoading}>
            {isLoading ? 'Creating Account...' : <><FaRocket style={{ marginRight: 8 }} /> Create Account</>}
          </button>
        </form>

        <div className="auth-footer">
          <p>Already have an account? <Link to="/login">Login here</Link></p>
        </div>
      </div>
    </div>
  );
};

export default Register;
